<div class="recording-container">
  <div class="recording-aside">
    <evrideo-recording-assets-manager></evrideo-recording-assets-manager>
  </div>
  <div class="recording-main">
    <section class="header">
      <div class="tabs">
        <div
          *ngFor="let tab of tabs"
          [ngClass]="{ tab: true, active: tab.type == selectedTab }"
          [routerLink]="['/recording/' + tab.title]"
        >
          {{ tab.title | uppercase }}
        </div>
      </div>
      <div class="start-date-from-filter filter" *ngIf="selectedTab === 2">
        Start Date From:
        <dateinput [(current)]="recordingService.startDateFrom"></dateinput>
      </div>
      <div class="start-date-from-filter filter" *ngIf="selectedTab === 2">
        Start Date To:
        <dateinput [(current)]="recordingService.startDateTo"></dateinput>
      </div>
      <div class="show-last-filter" *ngIf="selectedTab === 2">
        Show Last:
        <icn-dropdown
          [allowMultiple]="false"
          [short]="true"
          [position]="'bottom'"
          [(selectedValue)]="recordingService.showLastCountSelectedValue"
        >
          <icn-dropdown-item
            *ngFor="let option of recordingService.showLastCountOptions"
            [value]="option.value"
            [title]="option.displayName"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>

      <div class="refresh-recordings" (click)="reloadCurrentRoute()">
        <span class="icon">↻</span>
        <span>Refresh</span>
      </div>
      <div
        class="add-new-recording"
        *ngIf="isSceduleTab()"
        (click)="createNewRecordingJob()"
      >
        <div inlineSVG="/assets/icons/plus-sign.svg"></div>
        <span>Add Recording Job</span>
      </div>
    </section>
    <router-outlet></router-outlet>
  </div>
</div>
